import React from "react";
import { FormGroup, InputGroup, Callout, Intent } from "@blueprintjs/core";
import { AccountForm } from "../../molecules/AccountForms";
import { Link } from "react-router-dom";
import styles from "./LoginForm.module.scss";

function LoginForm({
  isEmailPrefilled,
  email,
  password,
  error,
  disabled,
  loading,
  onEmailChange,
  onPasswordChange,
  onSubmit
}) {
  const bottomLinkComponent = (
    <div className={styles.registerWrapper}>
      <p className={styles.registerText}>
        Don't have a Video Squirrel account?{" "}
        <Link to="/register" style={{ color: "#FF3C7B" }}>
          Sign up
        </Link>
      </p>
    </div>
  );

  return (
    <AccountForm
      headerText="Sign in to your Video&nbsp;Squirrel Account"
      buttonText="Sign In!"
      bottomLinkComponent={bottomLinkComponent}
      disabled={disabled}
      loading={loading}
      onSubmit={onSubmit}
      fullButton={true}
      onboardingHeaderText={true}
    >
      <div className={styles.info}>
        Are you ready to create and discover new opportunities, track your sales
        and cash out on your progress? We bet you are.
      </div>

      {error && (
        <Callout
          intent={Intent.WARNING}
          title={error.title}
          style={{ marginBottom: "1em" }}
          icon={null}
        >
          {error.message}
        </Callout>
      )}

      <FormGroup label="EMAIL ADDRESS OR USERNAME" labelFor="email-input">
        <InputGroup
          id="email-input"
          autoCapitalize="none"
          autoCorrect="false"
          value={email}
          onChange={onEmailChange}
          disabled={isEmailPrefilled}
        />
      </FormGroup>

      <FormGroup label="PASSWORD" labelFor="password-input">
        <InputGroup
          id="password-input"
          type="password"
          autoCapitalize="none"
          autoCorrect="false"
          value={password}
          onChange={onPasswordChange}
        />
      </FormGroup>

      <div className={styles.lnkForgetPassword}>
        <Link to="/forgotPassword">Forgot Password</Link>
      </div>
    </AccountForm>
  );
}

export default LoginForm;
